import { useCallback, useRef, useState } from 'react';
import useWebStorage, { PERSISTED_STATE_STORAGE_KEYS } from '@app/component/web-storage/useWebStorage';

/**
 * The Full width choice of the Date based table.
 * The browser stores the choice per device, so the table opens at the last width on the next visit.
 */
export function useFullWidthTable(): [boolean, () => void] {
	const storage = useWebStorage();
	const storageRef = useRef(storage);
	storageRef.current = storage;
	const [isFullWidth, setIsFullWidth] = useState<boolean>(() => {
		try {
			return storage.getItem<boolean>(PERSISTED_STATE_STORAGE_KEYS.RATES_TABLE_FULL_WIDTH) === true;
		} catch {
			return false;
		}
	});
	const toggle = useCallback(() => {
		const next = !isFullWidth;
		setIsFullWidth(next);
		try {
			storageRef.current.setItem(PERSISTED_STATE_STORAGE_KEYS.RATES_TABLE_FULL_WIDTH, next);
		} catch {
			// Keep the current session usable when browser storage is unavailable.
		}
	}, [isFullWidth]);
	return [isFullWidth, toggle];
}
